import * as OptionsActions from '../../actions/dashboard/actions-options';
import { Options } from '../../models/dashboard/options';

export const initialState: Options = {
  filters: {
    turnover: 'AIR',
    dateType: 'segment_date',
    dateFrom: getInitialDate(0, 1),
    dateTo: getInitialDate(6, 0)
  },
  grouping: 'default',
  filterBy: 'value',
  chartDataOnly: false,
  agencies: '',
  selectedReport: 0
};

/* eslint-disable */
function getInitialDate(monthDiff: number, day: number): string {
  const today = new Date();
  const date = new Date(Date.UTC(today.getFullYear(), today.getMonth() + monthDiff, day));
  return [
    date.getFullYear(),
    (date.getMonth() + 1).toString().padStart(2, '0'),
    date
      .getDate()
      .toString()
      .padStart(2, '0')
  ].join('-');
}

/* eslint-disable */
export function reducer(state = initialState, action: OptionsActions.ActionList): Options {
  switch (action.type) {
    case OptionsActions.ActionTypes.Change: {
      return { ...state, ...action.payload.options, selectedReport: 0 };
    }

    case OptionsActions.ActionTypes.SelectReport: {
      return { ...state, selectedReport: action.payload.index };
    }

    case OptionsActions.ActionTypes.Reset: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
}
